import { render, staticRenderFns } from "./TeresaTab.vue?vue&type=template&id=462ad4de&scoped=true&"
import script from "./TeresaTab.vue?vue&type=script&lang=js&"
export * from "./TeresaTab.vue?vue&type=script&lang=js&"
import style0 from "./TeresaTab.vue?vue&type=style&index=0&id=462ad4de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462ad4de",
  null
  
)

export default component.exports